import { createReducer } from "@reduxjs/toolkit";

export default function loadingReducer(domainName: string) {
  return createReducer<boolean, any>(false, (builder: any) => {
    builder
      .addMatcher(
        (action: any) => action.type.startsWith(domainName) && action.type.endsWith("pending"),
        () => true
      )
      .addMatcher(
        (action: any) => action.type.startsWith(domainName) && action.type.endsWith("fulfilled"),
        () => false
      )
      .addMatcher(
        (action: any) => action.type.startsWith(domainName) && action.type.endsWith("rejected"),
        () => false
      );
  });
}
